import React from "react";
import Activities from "containers/Activities";
import { type ItemActionViewConfig } from "data/types";

type ItemActionViewActivityListConfig = ItemActionViewConfig & {
    /** whether this item is a Document or Folder */
    isDoc?: boolean,
    /** whether to allow adding notes
     * @default {boolean} false
     */
    showAddNote?: boolean,
    /** whether to show notes (comment) entries
     * @default {boolean} true
     */
    showNotes?: boolean,
    /** whether to show history entries
     * @default {boolean} false
     */
    showHistory?: boolean,
    /** whether to show retention info
     * @default {boolean} false
     */
    showRetentionInfo?: boolean,
    /** custom filter to apply to the activities
     * @default {null} null
     */
    customFilter?: string,
};

/**
 * shows the ActivityList
 *
 * @param {{ itemUri: string }} { itemUri }
 * @param {{ formatId: number }} { formatId }
 * @param {{ view: ItemActionViewActivityListConfig }} { view }
 */
const ItemView_ActivityList = ({
    itemUri,
    formatId,
    view,
}: {
    itemUri: string,
    formatId: number,
    view: ItemActionViewActivityListConfig,
}) => (
    <Activities
        isDoc={view.isDoc || false}
        itemUri={itemUri}
        formatId={formatId}
        showAddNote={view.showAddNote}
        showNotes={view.showNotes}
        showHistory={view.showHistory || false}
        showRetentionInfo={view.showRetentionInfo || false}
        showActions={false}
        customFilter={view?.customFilter}
    />
);

ItemView_ActivityList.displayName = "ItemViews.ActivityList";
export default ItemView_ActivityList;
